(function($) {
    /* Back To Top Button */
	$(function() {
		$(document).on('click', 'a.page-scroll', function(event) {
			var $anchor = $(this);
			$('html, body').stop().animate({
				scrollTop: $($anchor.attr('href')).offset().top - 80
			}, 600, 'easeInOutExpo');
			event.preventDefault();
		});
    });
})(jQuery);